import { render, staticRenderFns } from "./ManterTermoView.vue?vue&type=template&id=6f0efb18&scoped=true"
import script from "./ManterTermoView.vue?vue&type=script&lang=js"
export * from "./ManterTermoView.vue?vue&type=script&lang=js"
import style0 from "./ManterTermoView.vue?vue&type=style&index=0&id=6f0efb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0efb18",
  null
  
)

export default component.exports